module.exports = __webpack_public_path__ + "static/img/partner-logo4.31472a6d.jpg";